// ************************************************************************************************************************************************************
//
// CONFIDENTIAL
// Unpublished Work, Copyright 2023, Baxter Healthcare Corporation. All rights reserved.
// For use only by Baxter Healthcare Corporation.
// This document contains proprietary information. It must not be reproduced
// or disclosed to others without prior written approval.
//
// Filename: Header.js
// Description: This file is responsible to show Header
//
// ************************************************************************************************************************************************************
import * as React from "react";
import "../../../App.css";
import Menudrawer from "../Menudrawer/Menudrawer";
import { checkUserGroup } from "../Auth/_redux/authCrud";
import { OktaAuth } from "@okta/okta-auth-js";

class HeaderPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {   
      toShowHeader: false
    };
  }

  oktaAuth = new OktaAuth({
    issuer: process.env.REACT_APP_OKTA_DOMAIN,
    clientId: process.env.REACT_APP_OKTA_CLIENT_ID
  });

  componentDidMount() {
    this.check();
  }

  check() {
    setTimeout(() => {
      this.checkAdminUserGroup();
    }, 0);
  }
  /*
==================================================================================
Created On : 23/10/2023
Purpose: Super Admin Login
==================================================================================
*/

  checkAdminUserGroup = () => {
    checkUserGroup()
      .then((res) => {
        const { status } = res.data;
        if (!status) {
          localStorage.setItem("Logout", "Login unsuccessful.");
          this.oktaAuth.signOut();
        }
        else{
          this.setState({
            ...this.state,
            toShowHeader: true
          });
        }
      })
      .catch((error) => {
        if (!error.response) {
          localStorage.setItem("Logout", "Network Error.");
        } else {
          localStorage.setItem("Logout", "Login unsuccessful.");
        }
        this.oktaAuth.signOut();
      });
  };

  render() {
    return <div>{this.oktaAuth.isAuthenticated && this.state.toShowHeader ? <Menudrawer /> : null}</div>;
  }
}
export default HeaderPage;
